import { channelManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const channelManagementRouteMetadata: IRouteMetadataObj<
  typeof channelManagementRoutesObj
> = {
  list: {
    title: "channelManagement.index.title",
    description: "channelManagement.index.description",
    lazy: () => import("@/pages/channelManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "ChatQuoteLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher, IRoleEnum.ASSISTANT],
  },
  view: {
    title: "channelManagement.view.title",
    description: "empty",
    lazy: () => import("@/pages/chat/page"),
    mode: "view",
    type: "inner",
    icon: "Message3Line",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.ASSISTANT],
    isPageFullMode: true,
  },
  edit: {
    title: "channelManagement.view.title",
    description: "empty",
    lazy: () => import("@/pages/chat/page"),
    mode: "edit",
    type: "inner",
    icon: "Message3Line",
    breadcrumbs: [],
    permission: [IRoleEnum.Teacher],
    isPageFullMode: true,
  },
};

export const channelManagementRoutes = createRoute<
  typeof channelManagementRoutesObj
>(channelManagementRoutesObj, channelManagementRouteMetadata);
